import { Loader2 } from 'lucide-react'
import { cn } from '../../lib/utils'

interface LoadingStateProps {
  fullPage?: boolean
  className?: string
}

export function LoadingState({ fullPage, className }: LoadingStateProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        fullPage ? 'min-h-[60vh]' : 'py-12',
        className
      )}
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary-600" />
    </div>
  )
}
